import { ScheduleStartLocation } from '..';

export const emptyScheduleStartLocation: ScheduleStartLocation = {
  // @ts-expect-error
  uuid: null,
  // @ts-expect-error
  name: null,
  // @ts-expect-error
  address: null,
  isDefault: false,
};
